<template>
  <div class="grid-view">
    <div class="main-content">
      <!--整箱 干线运价-->
      <div v-if="trunkLineEnable && type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code">
        <span>{{ $t('CargoMsg.Cargo_MainlineRate') }}</span>
        <div class="section grid-wrapper">
          <cargo-ag-grid-wrapper
            config-module="2025050241"
            :grid-options="fcl.gridOptions"
            :column-defs="fcl.columnDefs"
            :row-data="trunkLineData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params => { fcl.gridApi = params.api }"
          />
        </div>
        <div v-if="dataType === SystemConstants.DATA_TYPE_PRICE.code" class="pagination-wrapper">
          <cargo-pagination
            config-module="2025050241"
            :total="trunkLineDataTotal"
            :page.sync="fcl.filter.pageNum"
            :limit.sync="fcl.filter.pageSize"
            @pagination="$emit('pagination', fcl.filter)"
          />
        </div>
      </div>
      <!--拼箱 干线运价-->
      <div v-if="trunkLineEnable && type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code">
        <span>{{ $t('CargoMsg.Cargo_MainlineRate') }}</span>
        <div class="section grid-wrapper">
          <cargo-ag-grid-wrapper
            config-module="2025061602"
            :grid-options="lcl.gridOptions"
            :column-defs="lcl.columnDefs"
            :row-data="trunkLineData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params => { lcl.gridApi = params.api }"
          />
        </div>
        <div v-if="dataType === SystemConstants.DATA_TYPE_PRICE.code" class="pagination-wrapper">
          <cargo-pagination
            config-module="2025061602"
            :total="trunkLineDataTotal"
            :page.sync="lcl.filter.pageNum"
            :limit.sync="lcl.filter.pageSize"
            @pagination="$emit('pagination', lcl.filter)"
          />
        </div>
      </div>
      <!--港前运价-->
      <div v-if="prePortEnable">
        <span>{{ $t('CargoMsg.Cargo_PrePortRate') }}</span>
        <div class="section grid-wrapper">
          <cargo-ag-grid-wrapper
            config-module="2025050242"
            :grid-options="prePort.gridOptions"
            :column-defs="prePort.columnDefs"
            :row-data="prePortData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params => { prePort.gridApi = params.api }"
          />
        </div>
        <div v-if="dataType === SystemConstants.DATA_TYPE_PRICE.code" class="pagination-wrapper">
          <cargo-pagination
            config-module="2025050242"
            :total="prePortDataTotal"
            :page.sync="prePort.filter.pageNum"
            :limit.sync="prePort.filter.pageSize"
            @pagination="$emit('pagination', prePort.filter)"
          />
        </div>
      </div>
      <!--尾程运价-->
      <div v-if="lastMileEnable">
        <span>{{ $t('CargoMsg.Cargo_EndRouteRate') }}</span>
        <div class="section grid-wrapper">
          <cargo-ag-grid-wrapper
            config-module="2025050243"
            :grid-options="lastMile.gridOptions"
            :column-defs="lastMile.columnDefs"
            :row-data="lastMileData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params => { lastMile.gridApi = params.api }"
          />
        </div>
        <div v-if="dataType === SystemConstants.DATA_TYPE_PRICE.code" class="pagination-wrapper">
          <cargo-pagination
            config-module="2025050243"
            :total="lastMileDataTotal"
            :page.sync="lastMile.filter.pageNum"
            :limit.sync="lastMile.filter.pageSize"
            @pagination="$emit('pagination', lastMile.filter)"
          />
        </div>
      </div>
    </div>
    <!--运价-->
    <!--整箱运价-详情弹窗-->
    <price-dialog
      v-if="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code && type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code"
      :visible="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code && type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code"
      :price="trunkLineDetailDialog.data"
      :price-addon="null"
      :is-dangerous="null"
      :level="0"
      @close="trunkLineDetailDialog.visible = false"
    />
    <!--拼箱运价-详情弹窗-->
    <price-dialog
      v-if="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code && type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code"
      :visible="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code && type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code"
      :is-fcl="false"
      :price="trunkLineDetailDialog.data"
      :level="0"
      @close="trunkLineDetailDialog.visible = false"
    />
    <!--空运运价-详情弹窗-->
    <air-price-dialog
      v-if="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code && type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code"
      :visible="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code && type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code"
      :price="trunkLineDetailDialog.data"
      @close="trunkLineDetailDialog.visible = false"
    />
    <!--港前运价-详情弹窗-->
    <el-dialog
      v-if="prePort.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code"
      :visible="prePort.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code"
      :close-on-click-modal="false"
      width="1537px"
      @close="prePort.detailDialog.visible = false"
    >
      <price-pre-port-detail ref="pricePrePortDetail" :look="true" :is-dialog="true" />
    </el-dialog>
    <!--尾程运价-详情弹窗-->
    <el-dialog
      v-if="lastMile.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code"
      :visible="lastMile.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_PRICE.code"
      :close-on-click-modal="false"
      width="1537px"
      @close="lastMile.detailDialog.visible = false"
    >
      <price-last-mile-detail ref="priceLastMileDetail" :look="true" :is-dialog="true" />
    </el-dialog>
    <!--报价-->
    <!--整箱、拼箱、空运 报价-详情弹窗-->
    <quotation-detail-dialog
      v-if="trunkLineDetailDialog.visible && dataType === SystemConstants.DATA_TYPE_QUOTATION.code"
      :visible.sync="trunkLineDetailDialog.quotationVisible"
      :model="trunkLineDetailDialog.data"
      :show-quotation-detail="true"
    />
    <!--港前报价-详情弹窗-->
    <el-dialog
      v-if="prePort.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_QUOTATION.code"
      :visible="prePort.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_QUOTATION.code"
      :close-on-click-modal="false"
      width="1537px"
      @close="prePort.detailDialog.visible = false"
    >
      <quotation-pre-port-detail ref="pricePrePortDetail" :is-dialog="true" />
    </el-dialog>
    <!--尾程报价-详情弹窗-->
    <el-dialog
      v-if="lastMile.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_QUOTATION.code"
      :visible="lastMile.detailDialog.visible && dataType === SystemConstants.DATA_TYPE_QUOTATION.code"
      :close-on-click-modal="false"
      width="1537px"
      @close="lastMile.detailDialog.visible = false"
    >
      <quotation-last-mile-detail ref="priceLastMileDetail" :is-dialog="true" />
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { DocumentManage } from '@/utils/commonUtil'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import priceDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/PriceDialog'
import airPriceDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/airPriceDialog'
import pricePrePortDetail from '@/components/Cargo/Price/pricePrePortDetail'
import priceLastMileDetail from '@/components/Cargo/Price/priceLastMileDetail'
import QuotationDetailDialog from '@/views/cargo/v0/Price/Quotation/components/quotationDetailDialog'
import quotationPrePortDetail from '@/components/Cargo/Quotation/quotationPrePortDetail'
import quotationLastMileDetail from '@/components/Cargo/Quotation/quotationLastMileDetail'
import { PriceAirUtil } from '@/class/cargo/model/utils/PriceAirUtil'
import { Quotation } from '@/class/model/price/Quotation'
import { deepClone } from '@/utils/index'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export default {
  name: 'PriceCombinationResult', // 询价-详情-匹配运价/报价、运价查询-整箱-组合查询
  components: { airPriceDialog, quotationLastMileDetail, quotationPrePortDetail, QuotationDetailDialog, pricePrePortDetail, priceLastMileDetail, priceDialog, cargoAgGridWrapper, searchItem, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    trunkLineEnable: { type: Boolean, default: true }, // 干线
    prePortEnable: { type: Boolean, default: true }, // 港前
    lastMileEnable: { type: Boolean, default: true }, // 尾程
    inquiryForm: { type: Object, default: null }, // 询价单基础信息（用于询价编号等展示）
    type: { type: Number, default: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code }, // 运价/询价类型 1-海运整箱、 2-海运拼箱、 3-空运
    dataType: { type: Number, default: SystemConstants.DATA_TYPE_PRICE.code }, // 来源 1-运价、 2-报价
    quotations: { type: Array, default: () => [] },
    trunkLineData: { type: Array, default: () => [] },
    prePortData: { type: Array, default: () => [] },
    lastMileData: { type: Array, default: () => [] },
    selectedTrunkLineData: { type: Object, default: null },
    selectedPrePortData: { type: Object, default: null },
    selectedLastMileData: { type: Object, default: null },
    trunkLineDataTotal: { type: Number, default: 0 },
    prePortDataTotal: { type: Number, default: 0 },
    lastMileDataTotal: { type: Number, default: 0 }
  },
  data() {
    return {
      ColumnUtils,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      trunkLineDetailDialog: {
        visible: false,
        data: null,
        quotationVisible: false
      },
      fcl: { // 整箱
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.fcl.selectedRows = this.fcl.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.fcl.selectedRow = event.data
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<input type="radio" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', '${code}')" />`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CreatBy'),
            field: 'modifiedBy',
            colId: 'modifiedBy',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RateCode'),
            field: 'priceNo',
            colId: 'priceNo',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ViewDetail'),
            width: 150,
            cellRenderer: params => {
              const viewDetailHandle = this.documentManage.getPath('viewDetailHandle')
              const priceQuotationType = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<div onclick="${viewDetailHandle}(${priceQuotationType}, '${params.data.uuid}')" style="display: inline-block;color:#006ebe;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div>`
            }
          },
          {
            headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          }, {
            headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
            }
          },
          {
            headerName: this.$t('Pricing.BeginDate'),
            width: 100,
            valueGetter: params => {
              return ColumnUtils.dateRangeLabelFunc(params.data.beginDate, params.data.endDate)
            }
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DirectOrTransshipment'), field: 'direct', colId: 'direct', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.showTypeLabelFunc(params.value === true ? SystemConstants.DIRECT_TRANSIT_DIRECT.code : SystemConstants.DIRECT_TRANSIT_TRANSIT.code,
                SystemConstants.DIRECT_TRANSITS)
            }
          },
          {
            headerName: '20GP', field: 'cost20', colId: 'cost20', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.eqPriceLabel(params.value)
            }
          },
          // {
          //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
          // },
          {
            headerName: '40GP', field: 'cost40', colId: 'cost40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.eqPriceLabel(params.value)
            }
          },
          {
            headerName: '40HC', field: 'costhc', colId: 'costhc', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.eqPriceLabel(params.data.costhc ? params.data.costhc : params.data.costHc)
            }
          },
          {
            headerName: '45HC', field: 'cost45', colId: 'cost45', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.eqPriceLabel(params.value)
            }
          },
          {
            headerName: '20NOR', field: 'cost20nor', colId: 'cost20nor', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.eqPriceLabel(params.value)
            }
          },
          {
            headerName: '40NOR', field: 'cost40nor', colId: 'cost40nor', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.eqPriceLabel(params.value)
            }
          },
          {
            headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FreeUseContainer'), field: 'freeTime', colId: 'freeTime', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnclnTimeFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FreeStorage'), field: 'freeStorage', colId: 'freeStorage', width: 200,
            cellRenderer: (params) => {
              return params.value > 0 ? params.value + this.$t('CargoMsg.Cargo_Days') : ''
            }
          },
          {
            headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.closingDayFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200 },
          {
            headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }
        ],
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
          priceTypes: [SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code]
        }
      },
      lcl: { // 拼箱
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.lcl.selectedRows = this.lcl.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.lcl.selectedRow = event.data
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<input type="radio" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', '${code}')" />`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CreatBy'),
            field: 'solveUserId',
            colId: 'solveUserId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RateCode'),
            field: 'priceNo',
            colId: 'priceNo',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ViewDetail'),
            width: 150,
            cellRenderer: params => {
              const viewDetailHandle = this.documentManage.getPath('viewDetailHandle')
              const priceQuotationType = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<div onclick="${viewDetailHandle}(${priceQuotationType}, '${params.data.uuid}')" style="display: inline-block;color:#006ebe;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div>`
            }
          },
          {
            headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          }, {
            headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
            }
          },
          {
            headerName: this.$t('Pricing.BeginDate'),
            width: 100,
            valueGetter: params => {
              return ColumnUtils.dateRangeLabelFunc(params.data.beginDate, params.data.endDate)
            }
          },
          // zrd todo 应该只有 重量价成本、体积价成本 吧？待确认
          // {
          //   headerName: this.$t('Pricing.CostPrice') + '(TON)', field: 'costWeightPrice', colId: 'costWeightPrice', width: 85,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.CostPrice') + '(CBM)', field: 'costVolumePrice', colId: 'costVolumePrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.ColoaderPrice') + '(TON)', field: 'oneWeightPrice', colId: 'oneWeightPrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.ColoaderPrice') + '(CBM)', field: 'oneVolumePrice', colId: 'oneVolumePrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.CustomerPrice') + '(TON)', field: 'twoWeightPrice', colId: 'twoWeightPrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.CustomerPrice') + '(CBM)', field: 'twoVolumePrice', colId: 'twoVolumePrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.MarketPrice') + '(TON)', field: 'threeWeightPrice', colId: 'threeWeightPrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          // {
          //   headerName: this.$t('Pricing.MarketPrice') + '(CBM)', field: 'threeVolumePrice', colId: 'threeVolumePrice', width: 200,
          //   cellRenderer: (params) => {
          //     return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          //   }
          // },
          {
            headerName: this.$t('Pricing.WeightCost'), field: 'weightCost', colId: 'weightCost', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
            }
          },
          {
            headerName: this.$t('Pricing.VolumeCost'), field: 'volumeCost', colId: 'volumeCost', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
            }
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DirectOrTransshipment'), field: 'direct', colId: 'direct', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.showTypeLabelFunc(params.value === true ? SystemConstants.DIRECT_TRANSIT_DIRECT.code : SystemConstants.DIRECT_TRANSIT_TRANSIT.code,
                SystemConstants.DIRECT_TRANSITS)
            }
          },
          {
            headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
            }
          },
          {
            headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.closingDayFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.DepartureDay'), field: 'frequency', colId: 'frequency8', width: 200 },
          {
            headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }
        ],
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
          priceTypes: [SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code]
        }
      },
      air: { // // 空运
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.air.selectedRows = this.air.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.air.selectedRow = event.data
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<input type="radio" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', '${code}')" />`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CreatBy'),
            field: 'solveUserId',
            colId: 'solveUserId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RateCode'),
            field: 'priceNo',
            colId: 'priceNo',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ViewDetail'),
            width: 150,
            cellRenderer: params => {
              const viewDetailHandle = this.documentManage.getPath('viewDetailHandle')
              const priceQuotationType = SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code
              return `<div onclick="${viewDetailHandle}(${priceQuotationType}, '${params.data.uuid}')" style="display: inline-block;color:#006ebe;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div>`
            }
          },
          {
            headerName: this.$t('Invoice.Origin'), field: 'pol', colId: 'pol', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_Destination'), field: 'pod', colId: 'pod', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Pricing.Carrier_Air'), field: 'carrier', colId: 'carrier', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
                'cmpIdx', params.value, 'shortName')
            }
          },
          {
            headerName: this.$t('Pricing.BeginDate'),
            width: 100,
            valueGetter: params => {
              return ColumnUtils.dateRangeLabelFunc(params.data.beginDate, params.data.endDate)
            }
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DirectOrTransshipment'), field: 'direct', colId: 'direct', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.showTypeLabelFunc(params.value === true ? SystemConstants.DIRECT_TRANSIT_DIRECT.code : SystemConstants.DIRECT_TRANSIT_TRANSIT.code,
                SystemConstants.DIRECT_TRANSITS)
            }
          },
          {
            headerName: '+45', field: 'p45', colId: 'p45', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.airPriceLabel(params.value)
            }
          },
          {
            headerName: '+100', field: 'p100', colId: 'p100', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.airPriceLabel(params.value)
            }
          },
          {
            headerName: '+300', field: 'p300', colId: 'p300', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.airPriceLabel(params.value)
            }
          },
          {
            headerName: '+500', field: 'p500', colId: 'p500', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.airPriceLabel(params.value)
            }
          },
          {
            headerName: '+1000', field: 'p1000', colId: 'p1000', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.airPriceLabel(params.value)
            }
          },
          {
            headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.value)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
            }
          },
          {
            headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.closingDayFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Flight'), field: 'flight', colId: 'flight', width: 200,
            cellRenderer: (params) => {
              return PriceAirUtil.serviceItemLabelFunction(params.data, params.value)
            }
          },
          {
            headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }
        ],
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
          priceTypes: [SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code]
        }
      },
      prePort: { // 港前
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.prePort.selectedRows = this.prePort.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.prePort.selectedRow = event.data
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code
              return `<input type="radio" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', '${code}')" />`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CreatBy'),
            field: 'solveUserId',
            colId: 'solveUserId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RateCode'),
            field: 'priceNo',
            colId: 'priceNo',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ViewDetail'),
            width: 150,
            cellRenderer: params => {
              const viewDetailHandle = this.documentManage.getPath('viewDetailHandle')
              const priceQuotationType = SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code
              return `<div onclick="${viewDetailHandle}(${priceQuotationType}, '${params.data.uuid}')" style="display: inline-block;color:#006ebe;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div>`
            }
          }, {
            headerName: this.$t('Pricing.PriceType'),
            field: 'priceMethod',
            colId: 'priceMethod',
            width: 80,
            cellRenderer: (params) => {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PRICE_METHODS)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SubscribePOL'),
            colId: 'priceRegionStr',
            field: 'priceRegionStr',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'pol',
            colId: 'pol',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.getSeaAirPortLabel(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Vendor'),
            field: 'supplier',
            colId: 'supplier',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getFirstPriceCurrency(params.data)
            }
          },
          {
            headerName: '20GP',
            field: 'gp20',
            colId: 'gp20',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'gp20')
            }
          },
          // {
          //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
          // },
          {
            headerName: '40GP', field: 'gp40', colId: 'gp40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'gp40')
            }
          },
          {
            headerName: '40HC', field: 'hc40', colId: 'hc40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'hc40')
            }
          },
          {
            headerName: '45HC', field: 'hc45', colId: 'hc45', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'hc45')
            }
          },
          {
            headerName: '20NOR', field: 'nor20', colId: 'nor20', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'nor20')
            }
          },
          {
            headerName: '40NOR', field: 'nor40', colId: 'nor40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'nor40')
            }
          },
          {
            headerName: this.$t('Pricing.BeginDate'),
            width: 100,
            valueGetter: params => {
              return ColumnUtils.dateRangeLabelFunc(params.data.beginDate, params.data.endDate)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Remarks'),
            field: 'remarks',
            colId: 'remarks',
            width: 150,
            tooltipValueGetter: (params) => {
              return params.value
            }
          }
        ],
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
          priceTypes: [SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code]
        },
        detailDialog: {
          visible: false,
          data: null
        }
      },
      lastMile: { // 尾程
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.lastMile.selectedRows = this.lastMile.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.lastMile.selectedRow = event.data
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Select'),
            width: 150,
            field: 'selected',
            cellRenderer: params => {
              const radioClickHandler = this.documentManage.getPath('radioClickHandler')
              const code = SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code
              return `<input type="radio" ${params.value ? `checked="checked"` : ``} onclick="${radioClickHandler}('${params.data.uuid}', '${code}')" />`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CreatBy'),
            field: 'solveUserId',
            colId: 'solveUserId',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RateCode'),
            field: 'priceNo',
            colId: 'priceNo',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ViewDetail'),
            width: 150,
            cellRenderer: params => {
              const viewDetailHandle = this.documentManage.getPath('viewDetailHandle')
              const priceQuotationType = SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code
              return `<div onclick="${viewDetailHandle}(${priceQuotationType}, '${params.data.uuid}')" style="display: inline-block;color:#006ebe;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
            field: 'pod',
            colId: 'pod',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.getSeaAirPortLabels(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DeliveryAddressType'),
            colId: 'deliveryAddressType',
            field: 'deliveryAddressType',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.DELIVERY_ADDRESS_TYPES)
            }
          },
          // zrd todo 邮编
          {
            headerName: this.$t('SeaExport.Addr'),
            field: 'address',
            colId: 'address',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_WarehouseCode2'),
            field: 'warehouseCode',
            colId: 'warehouseCode',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.ProxyName'),
            field: 'agentName',
            colId: 'agentName',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getFirstPriceCurrency(params.data)
            }
          },
          {
            headerName: '20GP',
            field: 'gp20',
            colId: 'gp20',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'gp20')
            }
          },
          // {
          //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
          // },
          {
            headerName: '40GP', field: 'gp40', colId: 'gp40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'gp40')
            }
          },
          {
            headerName: '40HC', field: 'hc40', colId: 'hc40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'hc40')
            }
          },
          {
            headerName: '45HC', field: 'hc45', colId: 'hc45', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'hc45')
            }
          },
          {
            headerName: '20NOR', field: 'nor20', colId: 'nor20', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'nor20')
            }
          },
          {
            headerName: '40NOR', field: 'nor40', colId: 'nor40', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.getEqSizeLabel(params.data, 'nor40')
            }
          },
          {
            headerName: this.$t('Pricing.BeginDate'),
            width: 100,
            valueGetter: params => {
              return ColumnUtils.dateRangeLabelFunc(params.data.beginDate, params.data.endDate)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Remarks'),
            field: 'remarks',
            colId: 'remarks',
            width: 150,
            tooltipValueGetter: (params) => {
              return params.value
            }
          }
        ],
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
          priceTypes: [SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code]
        },
        detailDialog: {
          visible: false,
          data: null
        }
      },
      documentManage: new DocumentManage()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('viewDetailHandle', function(priceQuotationType, uuid) {
      context.viewDetailHandle(priceQuotationType, uuid)
    })
    this.documentManage.set('radioClickHandler', function(uuid, type) {
      context.radioClickHandler(uuid, type)
    })
  },
  methods: {
    async loadQuotationChargeDetailTo(targetQuotation, quotationUuid) {
      if (!targetQuotation || !quotationUuid) return
      const jobModel = new Quotation({ uuid: quotationUuid })
      jobModel.quotationChargeDetail = ''
      await jobModel.loadQuotationRelated({ quotationChargeDetail: true })
      targetQuotation.quotationChargeDetail = jobModel.quotationChargeDetail || []
    },
    buildQuotationModelFromSelected(baseQuotation, detail, quotationUuid) {
      const inquiry = this.inquiryForm ? deepClone(this.inquiryForm) : {}
      const selectedQuotation = Array.isArray(this.quotations)
        ? (this.quotations.find(q => q && q.uuid === quotationUuid) || {})
        : {}
      const selectedDetail = detail ? deepClone(detail) : {}
      const model = baseQuotation ? deepClone(baseQuotation) : {}

      Object.assign(model, inquiry, selectedQuotation, selectedDetail)
      model.uuid = quotationUuid
      model.quotationUuid = quotationUuid
      model.inquiryPriceNo = model.inquiryPriceNo || inquiry.inquiryPriceNo
      model.inquiryCreatedBy = model.inquiryCreatedBy || inquiry.createdBy
      return model
    },
    async viewDetailHandle(priceQuotationType, uuid) {
      const isPrice = SystemConstants.DATA_TYPE_PRICE.code === this.dataType
      if (isPrice) {
        if (SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code === priceQuotationType) {
          // 运价
          this.trunkLineDetailDialog.data = this.trunkLineData.find(p => p.uuid === uuid)
          this.trunkLineDetailDialog.visible = true
          return
        }
        if (SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code === priceQuotationType) {
          // 运价
          this.prePort.detailDialog.data = this.prePortData.find(p => p.uuid === uuid)
          this.prePort.detailDialog.visible = true
          this.$nextTick(() => {
            this.$refs.pricePrePortDetail.originForm = this.prePort.detailDialog.data
            this.$refs.pricePrePortDetail.form = this.prePort.detailDialog.data
          })
          return
        }
        if (SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code === priceQuotationType) {
          // 运价
          this.lastMile.detailDialog.data = this.lastMileData.find(p => p.uuid === uuid)
          this.lastMile.detailDialog.visible = true
          this.$nextTick(() => {
            this.$refs.priceLastMileDetail.originForm = this.lastMile.detailDialog.data
            this.$refs.priceLastMileDetail.form = this.lastMile.detailDialog.data
          })
        }
        return
      }

      // 报价
      if (SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code === priceQuotationType) {
        const detail = this.trunkLineData.find(p => p.uuid === uuid)
        if (!detail) return
        const quotationUuid = detail.quotationUuid || uuid
        const model = this.buildQuotationModelFromSelected(detail, detail, quotationUuid)
        if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
          model.type = PriceConstant.QUOTATION_FCL
          model.quotationFclDetail = [deepClone(detail)]
        } else if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code) {
          model.type = PriceConstant.QUOTATION_LCL
          model.quotationLclDetail = [deepClone(detail)]
        } else if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code) {
          model.type = PriceConstant.QUOTATION_AIR
          model.quotationAirDetail = [deepClone(detail)]
        }
        await this.loadQuotationChargeDetailTo(model, quotationUuid)
        this.trunkLineDetailDialog.data = model
        this.trunkLineDetailDialog.visible = true
        this.trunkLineDetailDialog.quotationVisible = true
        return
      }

      if (SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code === priceQuotationType) {
        const detail = this.prePortData.find(p => p.uuid === uuid)
        if (!detail) return
        const quotationUuid = detail.quotationUuid || uuid
        const model = this.buildQuotationModelFromSelected(null, detail, quotationUuid)
        model.prePortLastMileDetails = [deepClone(detail)]
        await this.loadQuotationChargeDetailTo(model, quotationUuid)

        this.prePort.detailDialog.data = model
        this.prePort.detailDialog.visible = true
        this.$nextTick(() => {
          this.$refs.pricePrePortDetail.originForm = this.prePort.detailDialog.data
          this.$refs.pricePrePortDetail.form = this.prePort.detailDialog.data
        })
        return
      }

      if (SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code === priceQuotationType) {
        const detail = this.lastMileData.find(p => p.uuid === uuid)
        if (!detail) return
        const quotationUuid = detail.quotationUuid || uuid
        const model = this.buildQuotationModelFromSelected(null, detail, quotationUuid)
        model.prePortLastMileDetails = [deepClone(detail)]
        await this.loadQuotationChargeDetailTo(model, quotationUuid)

        this.lastMile.detailDialog.data = model
        this.lastMile.detailDialog.visible = true
        this.$nextTick(() => {
          this.$refs.priceLastMileDetail.originForm = this.lastMile.detailDialog.data
          this.$refs.priceLastMileDetail.form = this.lastMile.detailDialog.data
        })
      }
    },
    radioClickHandler(uuid, type) {
      type = Number(type)
      let data
      let gridApi
      if (type === SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code) {
        data = this.trunkLineData
        if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
          gridApi = this.fcl.gridApi
        } else if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code) {
          gridApi = this.lcl.gridApi
        } else if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_AIR.code) {
          gridApi = this.air.gridApi
        }
      } else if (type === SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code) {
        data = this.prePortData
        gridApi = this.prePort.gridApi
      } else if (type === SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code) {
        data = this.lastMileData
        gridApi = this.lastMile.gridApi
      }
      let row
      data.forEach(p => {
        if (p.uuid === uuid) {
          p.selected = !p.selected
          row = p
        } else {
          p.selected = false
        }
      })
      gridApi.refreshCells({ force: true })
      this.$emit('radioClickHandler', row, type)
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
</style>
